import * as tokens from '@hover/tokens-size';
import * as tokens$1 from '@hover/tokens-space';

var sizes = {
  25: tokens.size25,
  50: tokens.size50,
  75: tokens.size75,
  100: tokens.size100,
  200: tokens.size200,
  300: tokens.size300,
  350: tokens.size350,
  375: tokens.size375,
  400: tokens.size400,
  500: tokens.size500,
  600: tokens.size600,
  700: tokens.size700,
  750: tokens.size750,
  800: tokens.size800,
  850: tokens.size850,
  900: tokens.size900,
  checkbox: {
    small: tokens.sizeCheckboxSmall,
    medium: tokens.sizeCheckboxMedium,
    large: tokens.sizeCheckboxLarge
  },
  radio: {
    small: tokens.sizeRadioSmall,
    medium: tokens.sizeRadioMedium,
    large: tokens.sizeRadioLarge
  }
};

var space = {
  0: tokens$1.size0,
  50: tokens$1.size50,
  100: tokens$1.size100,
  200: tokens$1.size200,
  300: tokens$1.size300,
  400: tokens$1.size400,
  500: tokens$1.size500,
  600: tokens$1.size600,
  700: tokens$1.size700,
  800: tokens$1.size800,
  900: tokens$1.size900,
  950: tokens$1.size950,
  1000: tokens$1.size1000,
  1100: tokens$1.size1100,
  1200: tokens$1.size1200
};

export { sizes as a, space as s };
